// extracted by mini-css-extract-plugin
export default {"row":"Home_row__hMriJ"};